// The animated Photon wordmark from the /photon hero: letterforms track the
// text color, the orbiting dot is the brand cyan. The orbit animation
// (photonm-orbit) is pure CSS in landing.css and honors
// prefers-reduced-motion.
export const PhotonWordmark = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 410 69" role="img" aria-label="Photon" className={className}>
    <path
      fill="currentColor"
      d="M15.60 67.20L8.10 67.20L8.10 1L37.90 1Q48.50 1 54.60 6.75Q60.70 12.50 60.70 22.30L60.70 22.30Q60.70 32.10 54.60 37.85Q48.50 43.60 37.90 43.60L37.90 43.60L15.60 43.60L15.60 67.20ZM15.60 8.10L15.60 36.60L37.40 36.60Q45.20 36.60 49.20 32.80Q53.20 29 53.20 22.30L53.20 22.30Q53.20 15.70 49.20 11.90Q45.20 8.10 37.40 8.10L37.40 8.10L15.60 8.10ZM78.40 67.20L70.90 67.20L70.90 1L78.40 1L78.40 30.40L116.90 30.40L116.90 1L124.40 1L124.40 67.20L116.90 67.20L116.90 37.70L78.40 37.70L78.40 67.20ZM170 68L170 68Q162.50 68 156.30 65.40Q150.10 62.80 145.65 58.10Q141.20 53.40 138.80 47.25Q136.40 41.10 136.40 34.10L136.40 34.10Q136.40 27 138.80 20.90Q141.20 14.80 145.65 10.10Q150.10 5.40 156.30 2.80Q162.50 0.20 170 0.20L170 0.20Q177.50 0.20 183.70 2.80Q189.90 5.40 194.35 10.10Q198.80 14.80 201.20 20.90Q203.60 27 203.60 34.10L203.60 34.10Q203.60 41.10 201.20 47.25Q198.80 53.40 194.35 58.10Q189.90 62.80 183.70 65.40Q177.50 68 170 68ZM170 60.70L170 60.70Q178.10 60.70 183.95 57.15Q189.80 53.60 192.95 47.55Q196.10 41.50 196.10 34.10L196.10 34.10Q196.10 26.60 192.95 20.60Q189.80 14.60 183.95 11.05Q178.10 7.50 170 7.50L170 7.50Q162 7.50 156.10 11.05Q150.20 14.60 147.05 20.60Q143.90 26.60 143.90 34.10L143.90 34.10Q143.90 41.50 147.05 47.55Q150.20 53.60 156.10 57.15Q162 60.70 170 60.70ZM236.70 67.20L229.20 67.20L229.20 8.10L206.10 8.10L206.10 1L259.80 1L259.80 8.10L236.70 8.10L236.70 67.20Z"
    />
    <g className="photonm-orbit">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="7.5"
        d="M327.68,26.34 A30,30 0 1 1 306.46,5.12"
      />
      <circle cx="319.91" cy="12.89" r="6" fill="var(--brand-500)" />
    </g>
    <path
      fill="currentColor"
      d="M351.80 67.20L344.30 67.20L344.30 1L353 1L393.90 56.70L393.90 1L401.40 1L401.40 67.20L392.70 67.20L351.80 11.30L351.80 67.20Z"
    />
  </svg>
);

/** Hero eyebrow for the /photon subpages: the animated wordmark with an
    optional "· Section" suffix, replacing the plain "Photon · Section"
    text label. */
export const PhotonPageMark = ({ section }: { section?: string }) => (
  <div className="t-eyebrow photon-page-mark">
    <PhotonWordmark />
    {section ? <span>· {section}</span> : null}
  </div>
);
